<template>
    <Card :loading="parentComponent.loading" overlay :header="$t('categoryList')">

        <DataTable v-if="parentComponent.item" :items="items" :fields="fields">
            <template #cell(action)="{item}">
                <div class="d-flex gap-2 justify-content-end">
                    <ButtonIcon size="sm" icon="trash-2" variant="danger" :loading="isDeleting(item.id)" @click="deleteItem(item)" />
                </div>
            </template>
            <template #cell(name)="{item}">
                <Tree :options="[{entityId: item.id, text: item.name, children: null}]" :load-options="loadOptions(item)" :normalizer="normalizer" />
            </template>
            <template #afterTable>
                <ButtonIcon icon="plus" class="mt-4" @click="showModal()">{{ $t('add') }}</ButtonIcon>
            </template>
        </DataTable>

    </Card>
</template>



<script>
    import DataTable from '@/components/common/DataTable.vue';
    import Tree from '@/components/common/Tree.vue';

    export default {
        name: 'Categories',
        components: {
            DataTable,
            Tree,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                request: this.$req('producerProductGroups/groupCategories'),
                requestProductsTree: this.$req('space/ProductsTree'),
            };
        },
        computed: {
            fields() {
                return [
                    { key: 'id', label: this.$t('id') },
                    { key: 'name', label: this.$t('name') },
                    { key: 'action', label: '', tdClass: 'text-right', thClass: 'text-right' },
                ];
            },
            items() {
                return this.parentComponent.item.categories || [];
            },
            spaceId() {
                return this.$store.state.space.currentSpaceId;
            },
        },
        methods: {
            isDeleting(id) {
                return this.request.getLoading(`delete-${id}`);
            },
            deleteItem(item) {
                this.$bvModal
                    .msgBoxConfirm(this.$t('confirmYouWantDelete'), {
                        title: this.$t('confirm'),
                        okTitle: this.$t('yes'),
                        cancelTitle: this.$t('cancel'),
                        okVariant: 'danger',
                    })
                    .then(value => {
                        if (value) {
                            this.request
                                .id(`delete-${item.id}`)
                                .delete({ urlParams: { groupId: this.parentComponent.id, id: item.id } })
                                .then(() => {
                                    this.removeItem(item);
                                })
                                .catch(error => this.$toastr.error(error.message, this.$t('errorOccurred')));
                        }
                    });
            },
            removeItem(item) {
                const index = this.items.findIndex(el => el.id === item.id);
                if (index !== -1) this.items.splice(index, 1);
            },
            showModal() {
                this.parentComponent.showModal();
            },
            fetchCategoriesTree(categoryId) {
                return this.requestProductsTree.get({ urlParams: { spaceId: this.spaceId }, requestParams: { category: categoryId } });
            },
            loadOptions(item) {
                const loadOptions = ({ parentNode }) => this.fetchCategoriesTree(parentNode?.entityId || item.id);
                return loadOptions;
            },
            normalizer(node) {
                return {
                    id: node.entityId,
                    label: node.text,
                    children: node.children === true ? null : node.children,
                    isDisabled: false,
                };
            },
        },
    };
</script>
